
/**
 * AI响应事件类型
 */
export interface AIResponseEvent {
    page: number;
    size: number
}
export interface AIShareEvent {
    topicNo: string;
    conversationNos: string
}

export interface GetGoodFeedbackDetail {
    options: string[],
    other: string
}
export interface GetGoodFeedbackParams {
    conversationNo: string;
    feedback: string;
    detail:GetGoodFeedbackDetail;
}

export interface GetAIResponseOptions {
    mock?: boolean;
    stream?: boolean;
}

export interface ConversationParams {
    teamId?: string | number;
    topicNo?: string;
    question: string ;
    model?: string;
}
export enum AIEventType {
    SEARCH = 'SEARCH',
    QUESTION = 'QUESTION',
    THINK = 'THINK',
    ANSWER = 'ANSWER',
    RECOMMEND = 'RECOMMEND',
    END = 'END',
}
export enum FileType {
    PDF = 'PDF',
    MD = "MD"
}

export enum FeedbackLikeType {
    ACCURATE = 'ACCURATE',
    EASY_TO_UNDERSTAND = 'EASY_TO_UNDERSTAND',
    COMPREHENSIVE = 'COMPREHENSIVE',
}

export enum FeedbackDisLikeType {
    UNDERSTANDING_ERROR = 'UNDERSTANDING_ERROR',
    CONTENT_ERROR = 'CONTENT_ERROR',
    FORMAT_ERROR = 'FORMAT_ERROR',
}
export interface AIRecord {
    content: Record[];
    page: Page;
}

export interface Record  {
    topicName: string;
    topicNo: string;
    createTime:string
}

export interface TopicRecord {
    topicName: string;
}
export interface Page {
    number: number;
    size: number;
    totalElements: number;
    totalPages: number;
}
/**
 * 搜索结果引用
 */
export interface Citation {
    index: number;
    fileId: number;
    page: number;
    summary: string;
}

/**
 * 搜索结果文档
 */
export interface SearchDocument {
    type: string;
    fileId: number;
    fileName: string;
    labels: keyOfValue[];
    summary: string;
    knowledgeId: number;
    knowledgeName: string;
    inclusionDate: string;
    used?: boolean;
}


export interface keyOfValue {
    key: string;
    value: string;
}
/**
 * SEARCH事件数据
 */
export interface SearchEventData {
    citations: Citation[];
    docs: SearchDocument[];
}

/**
 * THINK事件数据
 */
export interface ThinkEventData {
    time: number;
    thinking: string;
}

/**
 * ANSWER事件数据
 */
export interface AnswerEventData {
    answer: string;
}

/**
 * RECOMMEND事件数据
 */
export interface RecommendEventData {
    recommend: string[];
}

/**
 * END事件数据
 */
export interface EndEventData {
    stopReason?: string;
    time: number;
}

/**
 * AI响应事件
 */
export interface AIEvent {
    id: string | number;
    event: AIEventType;
    data: SearchEventData | ThinkEventData | AnswerEventData | RecommendEventData | EndEventData;
}

/**
 * AI响应
 */
export interface AIResponse {
    conversationNo: string;
    question: string
    isOpen?: boolean;
    isThinkEnd?: boolean;
    events: AIEvent[];
    feedback?: string;
}

export interface HistoryList {
    answer: string;
    citations: Citation[];
    conversationNo: string;
    createdTime:string;
    files: SearchDocument[];
    query: string;
    reasoning: string,
    isOpen?: boolean,
    stopReason: string,
    feedback: string
}
export interface OldResponse {
    records?: HistoryList[];
    topicName?: string;
    topicNo?: string;
}

export interface records {
    answer: string;
    citations: Citation[];
    conversationNo: string;
    createdTime: string;
    files: SearchDocument[];
    query: string;
    reasoning: string;
}
/**
 * 获取AI响应请求
 */
export interface GetAIRequest {
    question: string;
    context?: string;
    language?: string;
    stream?: boolean;
}

/**
 * 获取AI响应
 */
